import React from 'react';

const QRIcon = () => {
    const dotStyle = {
        width: '6px',
        height: '6px',
        backgroundColor: '#333',
        borderRadius: '1px',
    };

    const qrStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridTemplateRows: 'repeat(5, 1fr)',
        gap: '2px',
        padding: '4px',
        backgroundColor: '#fff',
        border: '2px solid #333',
        borderRadius: '4px',
        boxSizing: 'content-box',
        width: 'fit-content',
    };

    const blackDots = [
        0, 1, 2, 4,
        5, 7, 9,
        10, 12, 14,
        16, 18, 19,
        20, 22, 23, 24,
    ];

    return (
        <div style={{ position: 'relative', display: 'inline-block', marginBottom: '40px' }}>
            {/* QR Code Grid */}
            <div style={qrStyle}>
                {Array.from({ length: 25 }, (_, i) => (
                    <div
                        key={i}
                        style={{
                            ...dotStyle,
                            backgroundColor: blackDots.includes(i) ? '#333' : '#fff',
                        }}
                    />
                ))}
            </div>

            {/* Animated Up Arrow Below */}
            <div
                style={{
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    marginTop: '10px',
                    width: 0,
                    height: 0,
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                    borderBottom: '10px solid #333',
                    animation: 'bounceUp 1s infinite',
                }}
            />

            {/* Bounce Animation */}
            <style>
                {`
                @keyframes bounceUp {
                    0%, 100% {
                        transform: translateX(-50%) translateY(0);
                    }
                    50% {
                        transform: translateX(-50%) translateY(-5px);
                    }
                }
            `}
            </style>
        </div>
    );

};

export default QRIcon;
